import React from 'react'
import PropTypes from 'prop-types'
import { usePanelPartDrop } from 'hooks/dash'
import { useMakeSelector } from 'hooks/redux'
import { makeGetCanParentDrop } from 'selectors/dash'
import { isObject } from 'utils/types'
import { StyledDropLocation } from './DropLocation.style'

const Location = ({ children, location }) => {
  const { canDrop, isOver, dropRef } = usePanelPartDrop({
    location,
  })

  const canParentDrop = useMakeSelector(makeGetCanParentDrop, location)

  return (
    <StyledDropLocation
      ref={dropRef}
      canDrop={canDrop || canParentDrop}
      isOver={isOver}
      location={location}
      data-testid="drop-location"
    >
      {children}
    </StyledDropLocation>
  )
}

const DropLocation = ({ children, location }) => {
  if (!location || isObject(location)) return null

  return <Location location={location}>{children}</Location>
}

Location.propTypes = {
  children: PropTypes.node,
  location: PropTypes.string,
}

DropLocation.propTypes = {
  children: PropTypes.node,
  location: PropTypes.string,
}

export default DropLocation
